(function () {
  'use strict';
  if (window.happyMugPostHogInstalled) return;
  window.happyMugPostHogInstalled = true;
  var started = false;
  var enabled = false;
  var viewed = false;
  var bootAttempts = 0;
  var allowedEvents = ['$pageview', 'product_viewed', 'homepage_banner_clicked', '$snapshot'];
  function hasConsent() {
    try {
      return window.Shopify.customerPrivacy.currentVisitorConsent().analytics === 'yes';
    } catch (error) { return false; }
  }
  function safePath() {
    return /^\/(account|cart|checkout|checkouts|orders|search|pages)/.test(window.location.pathname) ? null : window.location.pathname;
  }
  function capture(event, properties) {
    if (!enabled || !hasConsent() || !window.posthog || !window.posthog.__loaded || !safePath()) return;
    window.posthog.capture(event, properties || {});
  }
  function pageEvents() {
    if (viewed || !enabled || !hasConsent() || !safePath()) return;
    viewed = true;
    capture('$pageview', { $current_url: window.location.origin + safePath(), $pathname: safePath() });
    var product = safePath().match(/\/products\/([^/]+)$/);
    if (product) capture('product_viewed', { product_handle: product[1] });
  }
  function start() {
    if (started || !enabled || !hasConsent() || !safePath()) return;
    if (window.posthog && (window.posthog.__loaded || window.posthog.__SV)) return;
    started = true;
    !function(t,e){var o,n,p,r;e.__SV||(window.posthog && window.posthog.__loaded)||(window.posthog=e,e._i=[],e.init=function(i,s,a){function g(t,e){var o=e.split(".");2==o.length&&(t=t[o[0]],e=o[1]),t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}}p||((p=t.createElement("script")).type="text/javascript",p.crossOrigin="anonymous",p.async=!0,p.src=s.api_host.replace(".i.posthog.com","-assets.i.posthog.com")+"/static/array.js",p.onerror=function(){p=null},(r=t.getElementsByTagName("script")[0]).parentNode.insertBefore(p,r));var u=e;for(void 0!==a?u=e[a]=[]:a="posthog",u.people=u.people||[],Object.defineProperty(u,"toString",{configurable:!0,enumerable:!0,writable:!0,value:function(t){var e="posthog";return"posthog"!==a&&(e+="."+a),t||(e+=" (stub)"),e}}),Object.defineProperty(u.people,"toString",{configurable:!0,enumerable:!0,writable:!0,value:function(){return u.toString(1)+".people (stub)"}}),o="init capture register register_once register_for_session unregister opt_out_capturing has_opted_out_capturing opt_in_capturing reset isFeatureEnabled getFeatureFlag getFeatureFlagPayload reloadFeatureFlags group identify setPersonProperties setPersonPropertiesForFlags resetPersonPropertiesForFlags setGroupPropertiesForFlags resetGroupPropertiesForFlags resetGroups onFeatureFlags addFeatureFlagsHandler onSessionId getSurveys getActiveMatchingSurveys renderSurvey canRenderSurvey getNextSurveyStep".split(" "),n=0;n<o.length;n++)g(u,o[n]);e._i.push([i,s,a])},e.__SV=1)}(document,window.posthog||[]);
    window.posthog.init('phc_zLoqqjVduyjqSyThxqevNxzJQqGhEeL8h9vSPNMN2Y2P', {
      api_host: 'https://eu.i.posthog.com',
      defaults: '2026-05-30',
      autocapture: false,
      capture_pageview: false,
      capture_pageleave: false,
      disable_session_recording: false,
      session_recording: {
        maskAllInputs: true,
        maskTextSelector: '.ph-mask, #tee-artwork-form, .tee-artwork-form, #tee-form, .tee-form, [contenteditable="true"], #CartDrawer, #cart-container, #SearchDrawer',
        blockSelector: 'canvas, iframe, .ph-no-capture, #tee-gallery, .tee-gallery-content, #teeinblue-preview, [class*="tee-preview"], [id*="tee-preview"], .tee-file-upload, .tee-img-fluid, #cart-container, #CartDrawer, #quickviewModal',
        recordCanvas: false,
        collectFonts: false,
        inlineImages: false,
        maskCapturedNetworkRequestFn: function(request) {
          if (request.name) {
            try { var url = new URL(request.name, window.location.origin); request.name = url.origin + url.pathname; }
            catch (error) { return null; }
          }
          delete request.requestBody;
          delete request.responseBody;
          delete request.requestHeaders;
          delete request.responseHeaders;
          return request;
        }
      },
      enable_recording_console_log: false,
      capture_performance: false,
      capture_dead_clicks: false,
      capture_exceptions: false,
      disable_surveys: true,
      disable_external_dependency_loading: false,
      advanced_disable_feature_flags: true,
      person_profiles: 'never',
      save_referrer: false,
      request_batching: false,
      opt_out_capturing_by_default: true,
      opt_out_persistence_by_default: true,
      before_send: function(event) {
        if (!enabled || !hasConsent() || !safePath() || allowedEvents.indexOf(event.event) === -1) return null;
        var props = event.properties || {};
        ['$current_url', '$initial_current_url'].forEach(function(key) {
          if (props[key]) {
            try { var url = new URL(props[key]); props[key] = url.origin + url.pathname; }
            catch (error) { delete props[key]; }
          }
        });
        ['$referrer', '$initial_referrer', '$set', '$set_once'].forEach(function(key) { delete props[key]; });
        event.properties = props;
        return event;
      },
      loaded: function(instance) {
        if (enabled && hasConsent()) {
          instance.opt_in_capturing({ captureEventName: false });
          if (instance.startSessionRecording) instance.startSessionRecording();
          pageEvents();
        } else instance.opt_out_capturing();
      }
    });
  }
  function syncConsent() {
    enabled = hasConsent();
    if (!enabled) {
      viewed = false;
      if (started && window.posthog) {
        if (window.posthog.stopSessionRecording) window.posthog.stopSessionRecording();
        if (window.posthog.opt_out_capturing) window.posthog.opt_out_capturing();
      }
      return;
    }
    if (!started) start();
    else if (window.posthog && window.posthog.__loaded) {
      window.posthog.opt_in_capturing({ captureEventName: false });
      if (window.posthog.startSessionRecording) window.posthog.startSessionRecording();
      pageEvents();
    }
  }
  document.addEventListener('visitorConsentCollected', syncConsent);
  document.addEventListener('happyMugConsentChanged', syncConsent);
  document.addEventListener('click', function(event) {
    var link = event.target.closest && event.target.closest('#ishislideshow-carousel .christmas-button');
    if (!link) return;
    var slide = link.closest('.slideshow__item');
    var name = slide && slide.classList.contains('mama-slide') ? 'mama_daughter' :
      slide && slide.classList.contains('friends-slide') ? 'friends' : 'christmas';
    capture('homepage_banner_clicked', { banner: name });
  });
  function boot() {
    bootAttempts += 1;
    if (window.Shopify && window.Shopify.customerPrivacy) { syncConsent(); return; }
    if (window.Shopify && window.Shopify.loadFeatures) {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function(error) { if (!error) syncConsent(); });
    } else if (bootAttempts < 20) window.setTimeout(boot, 250);
  }
  boot();
})();
